import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";

export default function RouteComments() {
    const [commentSectionOpen, setCommentSectionOpen] = useState(false);
    return (
        <div className="overflow-hidden">
            {!commentSectionOpen &&
                <div
                    className="flex justify-center items-center cursor-pointer mb-2"
                    onClick={() => setCommentSectionOpen(!commentSectionOpen)}
                >
                    <div className="border-t border-gray-300 flex-grow"></div>
                    <div className="flex flex-col items-center ">
                        <span className="px-4">Show comments</span>
                        <div><FontAwesomeIcon icon={faChevronDown}/></div>
                    </div>
                    <div className="border-t border-gray-300 flex-grow"></div>
                </div>
            }

            {commentSectionOpen && (
                <>
                    <div
                        className="flex justify-center items-center cursor-pointer mb-2"
                        onClick={() => setCommentSectionOpen(!commentSectionOpen)}
                    >
                        <div className="border-t border-gray-300 flex-grow"></div>
                        <div className="flex flex-col items-center ">
                            <span className="px-4">Hide comments</span>
                            <div><FontAwesomeIcon icon={faChevronUp}/></div>
                        </div>
                        <div className="border-t border-gray-300 flex-grow"></div>
                    </div>

                    <div className="pt-3 font-bold flex flex-row justify-center items-center">
                        Coming soon!
                    </div>
                </>
            )}
        </div>
    );
}